import { type, string, Type, success, tuple } from 'io-ts';

type WeatherLinksRaw = [
    string,
    string,
    string,
];
const WeatherLinksRawType = tuple([
    string,
    string,
    string,
]);

type WeatherLinksParsed = {
    readonly todayLink: string;
    readonly tomorrowLink: string;
    readonly nextDaysLink: string;
};
const WeatherLinksParsedType = type({
    todayLink: string,
    tomorrowLink: string,
    nextDaysLink: string,
});

export const WeatherLinksType = WeatherLinksRawType.pipe(
    new Type<WeatherLinksParsed, WeatherLinksRaw, WeatherLinksRaw>(
        'WeatherLinks',
        WeatherLinksParsedType.is,
        (input) => success({ todayLink: input[0], tomorrowLink: input[1], nextDaysLink: input[2] }),
        (value) => [value.todayLink, value.todayLink, value.nextDaysLink],
    )
);
